// src/components/quality/charts/AssessmentsCountByTypeChart.js
import { useState, useEffect } from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const AssessmentsCountByTypeChart = ({ assessments, fieldOptions }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (!assessments || !fieldOptions) return;

    // Группируем оценки по типам оценок
    const distribution = {};
    
    // Получаем все типы оценок из fieldOptions
    const assessmentTypes = fieldOptions.assessment_type || [];
    
    // Инициализируем счетчики для всех типов оценок
    assessmentTypes.forEach(type => {
      distribution[type.option_value] = {
        label: type.option_text,
        count: 0
      };
    });

    // Подсчитываем количество оценок для каждого типа
    assessments.forEach(assessment => {
      const type = assessment.assessment_type;
      if (distribution[type]) {
        distribution[type].count++;
      }
    });

    // Преобразуем объект в массив для отображения
    const data = Object.entries(distribution)
      .map(([value, { label, count }]) => ({
        value,
        label,
        count
      }))
      .filter(item => item.count > 0);

    setChartData(data);
  }, [assessments, fieldOptions]);

  // Цвета для секторов диаграммы (нейтральные и сдержанные)
  const colors = [
    '#63B3ED', '#4FD1C5', '#81E6D9', '#A0AEC0',
    '#D53F8C', '#805AD5', '#F687B3', '#68D391'
  ];

  // Подготавливаем данные для Chart.js
  const chartDataFormatted = {
    labels: chartData.map(item => item.label),
    datasets: [
      {
        data: chartData.map(item => item.count),
        backgroundColor: colors,
        borderColor: '#fff',
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        labels: {
          font: {
            size: 14
          },
          usePointStyle: true,
          generateLabels: function(chart) {
            const data = chart.data;
            const datasets = data.datasets[0];
            const total = datasets.data.reduce((a, b) => a + b, 0);
            
            return data.labels.map((label, i) => {
              const value = datasets.data[i];
              const percentage = ((value / total) * 100).toFixed(1);
              return {
                text: `${label}: ${value} (${percentage}%)`,
                fillStyle: datasets.backgroundColor[i],
                hidden: isNaN(datasets.data[i]) || datasets.data[i] === 0,
                index: i
              };
            });
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      },
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
          size: 14
        },
        formatter: (value, context) => {
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const percentage = ((value / total) * 100).toFixed(1);
          return `${value} (${percentage}%)`;
        },
        textAlign: 'center'
      }
    }
  };

  return (
    <div className="chart-card">
      <h3>Количество проверок по типам оценки</h3>
      {chartData.length === 0 ? (
        <div className="no-data">Нет данных для отображения</div>
      ) : (
        <div className="chart-container" style={{ display: 'flex', justifyContent: 'center', padding: '20px', height: '400px' }}>
          <Pie data={chartDataFormatted} options={options} />
        </div>
      )}
    </div>
  );
};

export default AssessmentsCountByTypeChart;